import { getNews, getNewsItem } from '../lib/data.js';
import { mediaUrl } from '../lib/supabase.js';
import { esc, formatDate } from '../lib/utils.js';

export async function renderAktuality(view) {
    const news = await getNews();

    view.innerHTML = `
        <section class="section narrow">
            <h1 class="page-title">Aktuality</h1>
            ${news.length ? `
                <div class="news-grid">
                    ${news.map((n) => `
                        <a class="news-card" href="#/aktuality/${n.id}">
                            ${n.image_path
                                ? `<div class="news-thumb" style="background-image:url('${esc(mediaUrl(n.image_path))}')"></div>`
                                : ''}
                            <div class="news-body">
                                <time>${formatDate((n.published_at || n.created_at || '').slice(0, 10))}</time>
                                <h3>${esc(n.title)}</h3>
                                <p>${esc(excerpt(n.body))}</p>
                            </div>
                        </a>`).join('')}
                </div>`
            : '<p class="empty">Zatím tu nejsou žádné aktuality. Brzy přibydou!</p>'}
        </section>
    `;
}

export async function renderAktualita(view, id) {
    const n = await getNewsItem(id);

    if (!n) {
        view.innerHTML = `
            <section class="section narrow">
                <h1 class="page-title">Aktualita nenalezena</h1>
                <p class="muted"><a href="#/aktuality">Zpět na aktuality</a></p>
            </section>`;
        return;
    }

    const img = mediaUrl(n.image_path);
    view.innerHTML = `
        <article class="section narrow article">
            <a class="back-link" href="#/aktuality">← Aktuality</a>
            <time class="article-date">${formatDate((n.published_at || n.created_at || '').slice(0, 10))}</time>
            <h1 class="page-title">${esc(n.title)}</h1>
            ${img ? `<img class="article-image" src="${esc(img)}" alt="${esc(n.title)}">` : ''}
            <div class="article-body">${paragraphs(n.body)}</div>
        </article>
    `;
}

function paragraphs(text) {
    return (text || '').split(/\n\s*\n/).map((p) =>
        `<p>${esc(p.trim()).replace(/\n/g, '<br>')}</p>`
    ).join('');
}

function excerpt(text, len = 140) {
    const t = (text || '').replace(/\s+/g, ' ').trim();
    return t.length > len ? t.slice(0, len) + '…' : t;
}
